import type { PusherService } from "@phurshell/psiapp-frontend-core/infra";
import { PusherServiceAdapter } from "@/app/adapters/PusherServiceAdapter";

// Conexão única com o Pusher do app (App.vue conecta/desconecta; o chat assina os canais).
// Importar este módulo já cria a instância.
export const pusherService: PusherService = new PusherServiceAdapter(
  process.env.VUE_APP_PUSHER_KEY as string,
  (process.env.VUE_APP_PUSHER_CLUSTER as string) || "us2",
);
